export enum PlayWebsocketClientToServerMessageType {
  GameStarted = 'game-started',
  SetCurrentGameVersion = 'set-current-game-version',
  GameFinished = 'game-finished',
}

export type PlayWebsocketClientToServerGameStarted = {
  type: PlayWebsocketClientToServerMessageType.GameStarted;
  startedAt: number;
};

export type PlayWebsocketClientToServerGameFinished = {
  type: PlayWebsocketClientToServerMessageType.GameFinished;
  duration: number;
};

export type PlayWebsocketClientToServerSetCurrentGameVersion = {
  type: PlayWebsocketClientToServerMessageType.SetCurrentGameVersion;
  version: number;
};

export type PlayWebsocketClientToServerMessage =
  | PlayWebsocketClientToServerGameStarted
  | PlayWebsocketClientToServerSetCurrentGameVersion
  | PlayWebsocketClientToServerGameFinished;

export const isPlayWebsocketClientToServerMessage = (
  message: unknown,
): message is PlayWebsocketClientToServerMessage => {
  if (typeof message !== 'object' || message === null) {
    return false;
  }

  if (!('type' in message) || typeof message.type !== 'string') {
    return false;
  }

  const validTypes = Object.values(PlayWebsocketClientToServerMessageType);

  return validTypes.includes(message.type as any);
};
